import {FC} from 'react';
import {LoginModalInitialPageContentProps} from '@liveComponents/Auth/LoginModal';
import {Typography} from '@components/Typography';
import {Icon} from '@components/Icon';
import {FormattedMessage} from 'react-intl';
import {Button} from '@components/Button';
import {PromoCard} from '@components/PromoCard';

const ContactOwner: FC<LoginModalInitialPageContentProps> = ({onLogin, onRegister}) => (
    <>
        <Typography as="p" textAlign="center" color="grey-dark" className="mb-8">
            <Icon.Star size="xl" />
        </Typography>

        <Typography as="h3" variant="h4" textAlign="center" className="mb-8">
            <FormattedMessage
                defaultMessage={'Pro kontaktování majitele je třeba se <strong>přihlásit</strong>.'}
                values={{
                    strong: (chunks: any) => <strong>{chunks}</strong>,
                }}
            />
        </Typography>

        <Typography as="p" textAlign="center" className="mb-4">
            <Button onClick={onLogin}>
                <FormattedMessage defaultMessage={'Přihlásit se'} />
            </Button>
        </Typography>

        <Typography as="p" variant="perex" color="grey-dark" className="mb-8" textAlign="center">
            <FormattedMessage
                defaultMessage={'Nemáte ještě účet? <link>Zaregistrujte se</link>'}
                values={{
                    link: (chunks: any) => (
                        <a className={'link'} role={'button'} onClick={onRegister}>
                            {chunks}
                        </a>
                    ),
                }}
            />
        </Typography>
    </>
);

export default ContactOwner;
